import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialDesignModule } from './material-design/material-design.module';

/*Intern Modules */
import { DirectConnectionComponent } from './components/head/direct-connection/direct-connection.component';
import { DirectConnectionDialogComponent } from './components/head/direct-connection/direct-connection.component';
import { SessionDialogComponent } from './components/session/session-dialog/session-dialog.component';
import { ConnectionManagerComponent } from './components/connection-manager/connection-manager.component';
import { NoPermitionComponent } from './components/head/permition/no-permition/no-permition.component';

import { HomeComponent } from './components/home/home.component';
import { HomeDialogComponent } from './components/home/home.component';
import { ToolbarComponent } from './components/head/toolbar/toolbar.component';
import { SidenavComponent } from './components/head/sidenav/sidenav.component';
import { AboutComponent } from './components/about/about.component';
import { LicenceComponent } from './components/about/licence/licence.component';
import { ReleaseNotesComponent } from './components/release-notes/release-notes.component';
import { ReleaseNotesMultiComponent } from './components/release-notes/release-notes-multi/release-notes-multi.component';
import { ComponentsComponent } from './components/release-notes/components/components.component';
import { MenuComponent } from './components/menu/menu/menu.component';
import { DiagConfigDialog } from './components/menu/menu/menu.component';

import { DataDisplayComponent } from './components/data/data-display/data-display.component';
import { QueryControlBarComponent } from './components/data/query-control-bar/query-control-bar.component';
import { MultipleDidDataTableComponent } from './components/data/multiple-did-data-table/multiple-did-data-table.component';
import { DidMappingTableComponent } from './components/data/dataIdentifier/did-mapping-table/did-mapping-table.component';
import { BasicMachineFunctionsViewsListComponent } from './components/basicFunctionsViews/basic-machine-functions-views-list/basic-machine-functions-views-list.component';
import { BasicViewContainerComponent } from './components/basicFunctionsViews/basic-machine-function-view/basic-view-container/basic-view-container.component';
import { BasicViewTableComponent } from './components/basicFunctionsViews/basic-machine-function-view/basic-view-table/basic-view-table.component';
import { BasicViewGraphComponent } from './components/basicFunctionsViews/basic-machine-function-view/basic-view-graph/basic-view-graph.component';
import { DidDataComponent } from './components/data/overview/did-data/did-data.component';
import { ParameterDataComponent } from './components/data/write-parameter/parameter-data/parameter-data.component';
import { ConfDialogComponent } from './components/data/write-parameter/confirmation-dialog/conf-dialog/conf-dialog.component';

import { DtcComponent } from './components/dtc/dtc.component';
import { InfoDialogComponent } from './components/dtc/InfoDialog/info-dialog/info-dialog.component';

import { BusVisualizationComponent } from './components/bus-visualization/bus-visualization.component';
import { BusSpecificDialog } from './components/bus-visualization/bus-visualization.component';

import { MachineOptionsComponent } from './components/machine-options/machine-options/machine-options.component';
import { AutoScrollDirective, ComissioningComponent } from './components/comissioning/comissioning.component';
import { ComissionDialog } from './components/comissioning/comissioning.component';
import { InOutComponent } from './components/general/in-out/in-out.component';
import { InOutOverviewComponent } from './components/general/overview/in-out-overview/in-out-overview.component';

/** Visualizations */
import { VisualizationDistributorComponent } from './components/visualization-distributor/visualization-distributor.component';
// GREEN
import { VisualizationsListComponent } from './components/visualizations/list/visualizations-list/visualizations-list.component';
import { JoystickMovementsComponent } from './components/visualizations/joysticks/movements/joystick-movements/joystick-movements.component';
import { TwoDirectionsPercentageSquareGridComponent } from './components/visualizations/common/two-directions-percentage-square-grid/two-directions-percentage-square-grid.component';
import { EquipmentCurrentsComponent } from './components/visualizations/currents/equipment-currents/equipment-currents.component';
import { EquipmentPressuresComponent } from './components/visualizations/pressure/equipment-pressures/equipment-pressures/equipment-pressures.component';
import { BoomStickPositionComponent } from './components/visualizations/boomStick/position/boom-stick-position/boom-stick-position.component';
import { MachineComponentsOperationHoursComponent } from './components/visualizations/operationTimes/machine-components-operation-hours/machine-components-operation-hours.component';

// MULIT
import { VisualizationsListMultiComponent } from './components/visualizations-multi/list/visualizations-list-multi/visualizations-list-multi.component';
import { JoystickMovementsMultiComponent } from './components/visualizations-multi/joystick/joystick-movements-multi/joystick-movements-multi.component';
import { EquipmentCurrentsMultiComponent } from './components/visualizations-multi/currents/equipment-currents-multi/equipment-currents-multi.component';
import { EquipmentPressuresMultiComponent } from './components/visualizations-multi/pressure/equipment-pressures-multi/equipment-pressures-multi.component';
import { MachineComponentsOperationHoursMultiComponent } from './components/visualizations-multi/operationTimes/machine-components-operation-hours-multi/machine-components-operation-hours-multi.component';
import { DriveMultiComponent } from './components/visualizations-multi/drive/drive-multi/drive-multi.component';
import { CalibrationMultiComponent } from './components/visualizations-multi/calibration/calibration-multi/calibration-multi.component';

/*Services*/
import { DidConfigService } from './services/apiHandler/did-config/did-config.service';
import { GatewayConnectionService } from './services/apiHandler/gateway-connection/gateway-connection.service';

/*Interceptor */
import { HeaderInterceptor } from './services/interceptor/header.interceptor';
import { ErrorInterceptor } from './services/interceptor/error.interceptor';


/*External modules */
import { NgApexchartsModule } from 'ng-apexcharts';
import * as PlotlyJS from 'plotly.js-dist-min';
import { PlotlyModule } from 'angular-plotly.js';
import { CommonModule } from '@angular/common';
import { OAuthModule } from 'angular-oauth2-oidc';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { initializeKeycloak } from './init/keycloak-init.factory';
import { KeycloakService } from 'keycloak-angular';



PlotlyModule.plotlyjs = PlotlyJS;

@NgModule({
    declarations: [
        AppComponent,
        ToolbarComponent,
        ConnectionManagerComponent,
        DataDisplayComponent,
        QueryControlBarComponent,
        MultipleDidDataTableComponent,
        HomeComponent,
        DidMappingTableComponent,
        BasicMachineFunctionsViewsListComponent,
        BasicViewContainerComponent,
        BasicViewTableComponent,
        BasicViewGraphComponent,
        VisualizationsListComponent,
        JoystickMovementsComponent,
        TwoDirectionsPercentageSquareGridComponent,
        BoomStickPositionComponent,
        MachineComponentsOperationHoursComponent,
        EquipmentCurrentsComponent,
        AboutComponent,
        LicenceComponent,
        DtcComponent,
        InfoDialogComponent,
        BusVisualizationComponent,
        BusSpecificDialog,
        MenuComponent,
        DidDataComponent,
        EquipmentPressuresComponent,
        MachineOptionsComponent,
        ParameterDataComponent,
        ConfDialogComponent,
        SessionDialogComponent,
        InOutComponent,
        InOutOverviewComponent,
        NoPermitionComponent,
        SidenavComponent,
        ReleaseNotesComponent,
        DirectConnectionComponent,
        DirectConnectionDialogComponent,
        HomeDialogComponent,
        VisualizationDistributorComponent,
        EquipmentCurrentsMultiComponent,
        VisualizationsListMultiComponent,
        MachineComponentsOperationHoursMultiComponent,
        EquipmentPressuresMultiComponent,
        JoystickMovementsMultiComponent,
        DriveMultiComponent,
        CalibrationMultiComponent,
        ReleaseNotesMultiComponent,
        ComponentsComponent,
        DiagConfigDialog,
        ComissioningComponent,
        ComissionDialog,
        AutoScrollDirective
    ],
    imports: [
        CommonModule,
        PlotlyModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MaterialDesignModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgApexchartsModule,
        OAuthModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [GatewayConnectionService, DidConfigService, {
        provide: APP_INITIALIZER,
        useFactory: initializeKeycloak,
        multi: true,
        deps: [KeycloakService]
    }, KeycloakService, {
        provide: HTTP_INTERCEPTORS,
        useClass: ErrorInterceptor,
        multi: true,
    }, {
        provide: HTTP_INTERCEPTORS, 
        useClass: HeaderInterceptor,
        multi: true,
    }],
    bootstrap: [AppComponent],
})
export class AppModule {}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http);
}
